// Vendor libraries
import { EventEmitter, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import * as i0 from "@angular/core";
import * as i1 from "@angular/platform-browser";
import * as i2 from "../modal-base/components/modal-base.component";
import * as i3 from "../modal-base/components/simple-modal-footer.component";
import * as i4 from "../modal-base/components/simple-modal-header.component";
/**
 *
 * Confirm Modal Component
 *
 * Input Properties:
 *
 *  confirmButtonText: Text used for the button that triggers a confirmation.
 *  cancelButtonText: Text use for the button that does not trigger a confirmation.
 *  confirmHeader: Text used for the header of the modal.
 *  confirmText: Text used in the modal content section.
 *  modalTestId: Used to set the data-test-id attributes of the modal's and its child components
 *                     (footer, confirm button, etc). Make sure this is as unique as possible to avoid test-breaking
 *                     collisions between two elements having the same `data-test-id`
 *  showCancelButton: Whether the cancel button should be shown. Defaults to true
 *  showConfirmButton: Whether the confirm button should be shown. Defaults to true
 *
 *
 * Output Properties:
 *
 *  confirmHandler: EventEmitter that emits when the user confirms or cancels
 *
 */
export class ConfirmModalComponent {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
        this.confirmTextClass = '';
        this.showCancelButton = true;
        this.showConfirmButton = true;
        this.closeModalHandler = new EventEmitter();
        this.confirmHandler = new EventEmitter();
        this.sanitizedText = '';
        this.modalOpen = false;
    }
    ngOnChanges() {
        this.sanitizedText = this.sanitizer.sanitize(SecurityContext.HTML, this.confirmText) ?? '';
    }
    openModal() {
        this.modalOpen = true;
    }
    closeModal() {
        this.modalOpen = false;
        this.closeModalHandler.emit();
    }
    submit(confirmed) {
        this.confirmHandler.emit(confirmed);
        this.closeModal();
    }
}
ConfirmModalComponent.ɵfac = function ConfirmModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ConfirmModalComponent)(i0.ɵɵdirectiveInject(i1.DomSanitizer)); };
ConfirmModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ConfirmModalComponent, selectors: [["ycn-confirm-modal"]], inputs: { confirmButtonText: "confirmButtonText", cancelButtonText: "cancelButtonText", confirmHeader: "confirmHeader", confirmText: "confirmText", confirmTextClass: "confirmTextClass", showCancelButton: "showCancelButton", showConfirmButton: "showConfirmButton", modalTestId: "modalTestId", confirmButtonClasses: "confirmButtonClasses" }, outputs: { closeModalHandler: "closeModalHandler", confirmHandler: "confirmHandler" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 6, vars: 14, consts: [[3, "closeModalHandler", "extraModalClasses", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "modal-section"], [3, "innerHTML"], [3, "cancelHandler", "submitHandler", "cancelButtonText", "submitButtonText", "submitButtonClasses", "showCancelButton", "showSubmitButton", "modalTestId"]], template: function ConfirmModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function ConfirmModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.submit(false); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function ConfirmModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.submit(false); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2)(3, "div", 3);
        i0.ɵɵelement(4, "div", 4);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "ycn-simple-modal-footer", 5);
        i0.ɵɵlistener("cancelHandler", function ConfirmModalComponent_Template_ycn_simple_modal_footer_cancelHandler_5_listener() { return ctx.submit(false); })("submitHandler", function ConfirmModalComponent_Template_ycn_simple_modal_footer_submitHandler_5_listener() { return ctx.submit(true); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("extraModalClasses", "modal-sm")("open", ctx.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", ctx.confirmHeader);
        i0.ɵɵadvance(3);
        i0.ɵɵclassMapInterpolate1("modal-message ", ctx.confirmTextClass, "");
        i0.ɵɵproperty("innerHTML", ctx.sanitizedText, i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance();
        i0.ɵɵproperty("cancelButtonText", ctx.cancelButtonText)("submitButtonText", ctx.confirmButtonText)("submitButtonClasses", ctx.confirmButtonClasses)("showCancelButton", ctx.showCancelButton)("showSubmitButton", ctx.showConfirmButton)("modalTestId", ctx.modalTestId);
        i0.ɵɵattribute("data-test-id", ctx.modalTestId ? ctx.modalTestId + "-footer" : ctx.confirmButtonText + "-footer");
    } }, dependencies: [i2.ModalBaseComponent, i3.SimpleModalFooterComponent, i4.SimpleModalHeaderComponent], encapsulation: 2 });
